import { ProtocolKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { TooltipDescription } from "../description";
import { IsolatedRiskContent } from "../market-header/isolated-risk";

interface HeadingProps {
  className?: string;
  protocolKey: ProtocolKey;
}

export function Heading({ className, protocolKey }: HeadingProps): JSX.Element {
  return (
    <div className={cn("flex gap-2.5 items-center", className)}>
      <h1 className="text-lg font-medium text-white md:text-2xl">
        Isolated markets (silos)
      </h1>
      <TooltipDescription placement="right-start">
        <IsolatedRiskContent protocolKey={protocolKey} />
      </TooltipDescription>
    </div>
  );
}
